<div class="upload-list">
  <div class="summary">
    <mat-icon>check_circle</mat-icon>{{ completedItems.length }}/{{
      items.length
    }}件のアップロードが完了
    <button class="toggle-button" (click)="expanded = !expanded">
      @if (!expanded) {
        <mat-icon>expand_more</mat-icon>
      }
      @if (expanded) {
        <mat-icon>expand_less</mat-icon>
      }
    </button>
    <button class="close-button" (click)="this.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (expanded) {
    <ul class="details">
      @for (item of items; track item) {
        <li
          class="detail"
          [class]="{
            completed: item.status === 'completed',
            error: item.status === 'error',
            'in-progress': item.status === 'in_progress',
          }"
        >
          <div class="left">
            @if (item.status === 'completed') {
              <mat-icon>check_circle_outline</mat-icon>
            }
            @if (item.status === 'error') {
              <mat-icon>error_outline</mat-icon>
            }
            @if (item.status === 'in_progress') {
              <mat-icon svgIcon="loading"></mat-icon>
            }
            <span>{{ item.name }}</span>
          </div>
          <div class="right">
            {{
              item.status === 'completed'
                ? '完了'
                : item.status === 'error'
                  ? '失敗'
                  : item.status === 'in_progress'
                    ? '実行中'
                    : ''
            }}
          </div>
        </li>
      }
    </ul>
  }
</div>
